import { setAuthHeader } from '../utils/axiosHeaders';
import environment from '../environment/environment';

export const setToken = (token: string | null) => {
  // In public mode, never store or use tokens
  if (environment.publicMode) {
    localStorage.removeItem('access_token');
    setAuthHeader();
    return;
  }

  if (token) {
    localStorage.setItem('access_token', token);
    setAuthHeader(token);
  } else {
    localStorage.removeItem('access_token');
    setAuthHeader();
  }
};

export const getToken = (): string | null => {
  // In public mode, never return tokens
  if (environment.publicMode) {
    return null;
  }
  return localStorage.getItem('access_token');
};
